import { useCallback, useState } from 'react';
export const useQueryParam = (key, defaultValue, func = value => value) => {
  const [value, _setValue] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const v = params.get(key);
    return v ? func(v) : defaultValue;
  });
  const setValue = useCallback(v => {
    const params = new URLSearchParams(window.location.search);
    if (typeof v === 'string' && !v || v === defaultValue) {
      params.delete(key);
    } else {
      params.set(key, typeof v === 'string' ? v : JSON.stringify(v));
    }
    window.history.replaceState(null, '', `?${params.toString()}${window.location.hash}`);
    _setValue(v);
  }, [key, defaultValue]);
  return [value, setValue];
};